import { Col, Row } from "antd";
import { useMemo } from "react";
import { ReservationOrderItemInfo } from "../../../../../model/Reservation/OrderItem";
import Badge from "../../../../atoms/Badge";
import { ProductStatusTag } from "../Products/ProductStatus";

interface ReservationExpendedListFormProps {
  orderItems?: Array<ReservationOrderItemInfo>;
}

/**
 * 리스트형식의 주문상품 정보
 * @history 231025, new
 */
export const ReservationExpendedListForm: React.FC<
  ReservationExpendedListFormProps
> = ({ orderItems = [] }) => {
  const list = useMemo(() => {
    const parsing = orderItems.reduce((a, b) => {
      if (b && typeof b.orderItemProductOptions === "object") {
        a = a.concat(
          b.orderItemProductOptions.map(
            (item) =>
              ({
                productType: b.productType,
                erpCode: item.erpCode,
                orderItemName: item.productOptionValue,
                amount: item.amount,
              } as ReservationOrderItemInfo)
          )
        );
      } else {
        a = a.concat(b);
      }
      return a;
    }, [] as ReservationOrderItemInfo[]);

    return parsing || [];
  }, [orderItems]);

  return (
    <>
      {list.map(
        (
          item: ReservationOrderItemInfo,
          idx: number,
          arr: ReservationOrderItemInfo[]
        ) => (
          <Row
            align="middle"
            justify="start"
            style={{
              margin: "0 0 0 243px",
              borderBottom:
                arr.length - 1 === idx ? undefined : "1px solid #eaeaea",
            }}
          >
            <Col flex="0 0 180px" style={{ padding: "12px 16px" }}>
              <ProductStatusTag value={item.productType} />
            </Col>
            <Col flex="0 0 240px" style={{ padding: "12px 16px" }}>
              <Badge ghost color="gray">
                {item.productType === "ETC" ? "WheelAlignment" : item.erpCode}
              </Badge>
            </Col>
            <Col flex="0 0 324px" style={{ padding: "12px 16px" }}>
              {item.orderItemName}
            </Col>
            <Col flex="0 0 100px" style={{ padding: "12px 16px" }}>
              {item.amount} 개
            </Col>
          </Row>
        )
      )}
    </>
  );
};
